var map = {
	"./AppLe.vue": "./src/icons/package/AppLe.vue",
	"./BanAna.vue": "./src/icons/package/BanAna.vue",
	"./BeerTwo.vue": "./src/icons/package/BeerTwo.vue",
	"./BooKmark.vue": "./src/icons/package/BooKmark.vue",
	"./BraInstorming.vue": "./src/icons/package/BraInstorming.vue",
	"./BreAd.vue": "./src/icons/package/BreAd.vue",
	"./BurGerbag.vue": "./src/icons/package/BurGerbag.vue",
	"./BusInessdialog.vue": "./src/icons/package/BusInessdialog.vue",
	"./BusInesstime.vue": "./src/icons/package/BusInesstime.vue",
	"./CaffeTatte.vue": "./src/icons/package/CaffeTatte.vue",
	"./CanDy.vue": "./src/icons/package/CanDy.vue",
	"./CapItaltwo.vue": "./src/icons/package/CapItaltwo.vue",
	"./CasHregister.vue": "./src/icons/package/CasHregister.vue",
	"./CheEseburger.vue": "./src/icons/package/CheEseburger.vue",
	"./CheRry.vue": "./src/icons/package/CheRry.vue",
	"./ChiCken.vue": "./src/icons/package/ChiCken.vue",
	"./ChiCkenlegs.vue": "./src/icons/package/ChiCkenlegs.vue",
	"./CocktailTwo.vue": "./src/icons/package/CocktailTwo.vue",
	"./CoffeeTithTarvhmallow.vue": "./src/icons/package/CoffeeTithTarvhmallow.vue",
	"./CoffeeToTo.vue": "./src/icons/package/CoffeeToTo.vue",
	"./CoffeeTupTevenTineTfive.vue": "./src/icons/package/CoffeeTupTevenTineTfive.vue",
	"./CoffeeTupTixTineT6.vue": "./src/icons/package/CoffeeTupTixTineT6.vue",
	"./ComBochart.vue": "./src/icons/package/ComBochart.vue",
	"./ComMunication.vue": "./src/icons/package/ComMunication.vue",
	"./CooKie.vue": "./src/icons/package/CooKie.vue",
	"./CorN.vue": "./src/icons/package/CorN.vue",
	"./CupCake.vue": "./src/icons/package/CupCake.vue",
	"./DrinkThree.vue": "./src/icons/package/DrinkThree.vue",
	"./DrinkTive.vue": "./src/icons/package/DrinkTive.vue",
	"./DrinkTour.vue": "./src/icons/package/DrinkTour.vue",
	"./EcoNomicimprovement.vue": "./src/icons/package/EcoNomicimprovement.vue",
	"./FinAncialanalytics.vue": "./src/icons/package/FinAncialanalytics.vue",
	"./FisH.vue": "./src/icons/package/FisH.vue",
	"./ForKknife.vue": "./src/icons/package/ForKknife.vue",
	"./FreNchfries.vue": "./src/icons/package/FreNchfries.vue",
	"./FriEs.vue": "./src/icons/package/FriEs.vue",
	"./GifT.vue": "./src/icons/package/GifT.vue",
	"./GifTboxtwothree.vue": "./src/icons/package/GifTboxtwothree.vue",
	"./GraPes.vue": "./src/icons/package/GraPes.vue",
	"./HotDog.vue": "./src/icons/package/HotDog.vue",
	"./IceCreamcone.vue": "./src/icons/package/IceCreamcone.vue",
	"./IceCreamconeo.vue": "./src/icons/package/IceCreamconeo.vue",
	"./IcedToffee.vue": "./src/icons/package/IcedToffee.vue",
	"./IdeA.vue": "./src/icons/package/IdeA.vue",
	"./InvEstmentportfolio.vue": "./src/icons/package/InvEstmentportfolio.vue",
	"./InvEstmenttime.vue": "./src/icons/package/InvEstmenttime.vue",
	"./IrivhToffee.vue": "./src/icons/package/IrivhToffee.vue",
	"./KonTanna.vue": "./src/icons/package/KonTanna.vue",
	"./LatteTacchiato.vue": "./src/icons/package/LatteTacchiato.vue",
	"./LemonadeTitcher.vue": "./src/icons/package/LemonadeTitcher.vue",
	"./LolLipop.vue": "./src/icons/package/LolLipop.vue",
	"./LoneTacchiato.vue": "./src/icons/package/LoneTacchiato.vue",
	"./LoneTrinkThree.vue": "./src/icons/package/LoneTrinkThree.vue",
	"./MarearitaTineTzero.vue": "./src/icons/package/MarearitaTineTzero.vue",
	"./MartiniTineTfive.vue": "./src/icons/package/MartiniTineTfive.vue",
	"./MedAl.vue": "./src/icons/package/MedAl.vue",
	"./MilkTottle.vue": "./src/icons/package/MilkTottle.vue",
	"./MonEybox.vue": "./src/icons/package/MonEybox.vue",
	"./MufFin.vue": "./src/icons/package/MufFin.vue",
	"./NegAtivedynamic.vue": "./src/icons/package/NegAtivedynamic.vue",
	"./NewContact.vue": "./src/icons/package/NewContact.vue",
	"./NooDleboxt.vue": "./src/icons/package/NooDleboxt.vue",
	"./NooDles.vue": "./src/icons/package/NooDles.vue",
	"./PacKage.vue": "./src/icons/package/PacKage.vue",
	"./PizZaboxes.vue": "./src/icons/package/PizZaboxes.vue",
	"./PizZat.vue": "./src/icons/package/PizZat.vue",
	"./PopSicle.vue": "./src/icons/package/PopSicle.vue",
	"./PorKleg.vue": "./src/icons/package/PorKleg.vue",
	"./PreSentationtwo.vue": "./src/icons/package/PreSentationtwo.vue",
	"./PreSentationtwoone.vue": "./src/icons/package/PreSentationtwoone.vue",
	"./RafToffee.vue": "./src/icons/package/RafToffee.vue",
	"./RoaStchicken.vue": "./src/icons/package/RoaStchicken.vue",
	"./SauSage.vue": "./src/icons/package/SauSage.vue",
	"./SauSaget.vue": "./src/icons/package/SauSaget.vue",
	"./ShrImp.vue": "./src/icons/package/ShrImp.vue",
	"./StaTistics.vue": "./src/icons/package/StaTistics.vue",
	"./SummerTrinkTineTc.vue": "./src/icons/package/SummerTrinkTineTc.vue",
	"./SusHit.vue": "./src/icons/package/SusHit.vue",
	"./TacO.vue": "./src/icons/package/TacO.vue",
	"./TakEaway.vue": "./src/icons/package/TakEaway.vue",
	"./TakEawaycoffeef.vue": "./src/icons/package/TakEawaycoffeef.vue",
	"./TakEawayfries.vue": "./src/icons/package/TakEawayfries.vue",
	"./TakEawayicecream.vue": "./src/icons/package/TakEawayicecream.vue",
	"./TakEawaypizza.vue": "./src/icons/package/TakEawaypizza.vue",
	"./TakEawaypizzabox.vue": "./src/icons/package/TakEawaypizzabox.vue",
	"./TakEawaysushi.vue": "./src/icons/package/TakEawaysushi.vue",
	"./TakEout.vue": "./src/icons/package/TakEout.vue",
	"./TakEoutboxt.vue": "./src/icons/package/TakEoutboxt.vue",
	"./TakEoutburger.vue": "./src/icons/package/TakEoutburger.vue",
	"./TakEoutburgert.vue": "./src/icons/package/TakEoutburgert.vue",
	"./TakEoute.vue": "./src/icons/package/TakEoute.vue",
	"./TakEouthotdog.vue": "./src/icons/package/TakEouthotdog.vue",
	"./TakEoutn.vue": "./src/icons/package/TakEoutn.vue",
	"./TakEoutof.vue": "./src/icons/package/TakEoutof.vue",
	"./TakEoutos.vue": "./src/icons/package/TakEoutos.vue",
	"./TakEoutsandwich.vue": "./src/icons/package/TakEoutsandwich.vue",
	"./TakEoutt.vue": "./src/icons/package/TakEoutt.vue",
	"./TakeTwayTrappe.vue": "./src/icons/package/TakeTwayTrappe.vue",
	"./TakeawayToffeevTineTthree.vue": "./src/icons/package/TakeawayToffeevTineTthree.vue",
	"./TimEtoinvest.vue": "./src/icons/package/TimEtoinvest.vue",
	"./TopOfsuccess.vue": "./src/icons/package/TopOfsuccess.vue",
	"./TroPhy.vue": "./src/icons/package/TroPhy.vue",
	"./VAmericano.vue": "./src/icons/package/VAmericano.vue",
	"./VBottle.vue": "./src/icons/package/VBottle.vue",
	"./VCola.vue": "./src/icons/package/VCola.vue",
	"./VDorzo.vue": "./src/icons/package/VDorzo.vue",
	"./VDrink.vue": "./src/icons/package/VDrink.vue",
	"./VDrinkv.vue": "./src/icons/package/VDrinkv.vue",
	"./VFrappe.vue": "./src/icons/package/VFrappe.vue",
	"./VGlace.vue": "./src/icons/package/VGlace.vue",
	"./VLemonade.vue": "./src/icons/package/VLemonade.vue",
	"./VLiquor.vue": "./src/icons/package/VLiquor.vue",
	"./VMarocchino.vue": "./src/icons/package/VMarocchino.vue",
	"./VMocha.vue": "./src/icons/package/VMocha.vue",
	"./VRivtretto.vue": "./src/icons/package/VRivtretto.vue",
	"./VTea.vue": "./src/icons/package/VTea.vue",
	"./VVienneve.vue": "./src/icons/package/VVienneve.vue",
	"./VWallet.vue": "./src/icons/package/VWallet.vue",
	"./VWater.vue": "./src/icons/package/VWater.vue",
	"./WalLet.vue": "./src/icons/package/WalLet.vue",
	"./WinNer.vue": "./src/icons/package/WinNer.vue",
	"./WineThree.vue": "./src/icons/package/WineThree.vue",
	"./WineTourTineTightseven.vue": "./src/icons/package/WineTourTineTightseven.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/package sync recursive \\.vue$";